import React from 'react'

const NewsContact = () => {
  return (
        <div className="news-contact">
            <div>
                <h1>For Media Inquiries Only</h1>
                <p><a href="mailto:pr@popshelf.com">pr@popshelf.com</a></p>
            </div>

            <div>
                <h1>For Customer Service Inquiries</h1>
                <p><a href="mailto:mailto:customercare@popshelf.com">customercare@popshelf.com</a></p>
            </div>

            <div>
                <h1>For Donation Inquiries</h1>
                <p><a href="mailto:donations@popshelf.com">donations@popshelf.com</a></p>
            </div>

            <div>
                <h1>Mailing Address</h1>
                <p>pOpshelf</p>
                <p>100 Mission Ridge</p>
                <p>Goodlettsville, Tennessee 37072</p>
            </div>
        </div>
  )
}

export default NewsContact
